// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import './Login.css';
// import DataCarousel from './DataCarousel';
// import Loader from './Loader';
// import { baseUrl } from '../data/data';

// const Carousel = ({ ani, service }) => {
//   console.log(service,"==service==")
//   const [banner, setBanner] = useState([]);
//   const [categoryname, setSubCategoryName] = useState('');
//   const [loading, setLoading] = useState(false);

//   // console.log("caro", service)s
//   const fetchSubscription = async () => {
//     try {
//       setLoading(true);
//       const res = await axios.get(`${baseUrl}/api/subscription/redirect/?msisdn=${ani}&service=${service}&result=active`);
//      console.log(res,"response===")
//       setSubCategoryName(res.data[0].category_name);
    
//       setLoading(false);
//     } catch (error) {
//       console.error('Error fetching subscription:', error);
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchSubscription();
//   }, [ani]);

//   const fetchBanners = async () => {
//     try {
//       setLoading(true);
//       console.log("===categoryname",categoryname)
//       const response = await axios.get(`${baseUrl}/api/banner/${categoryname}`);
//       setBanner(response.data);
//       setLoading(false);
//     } catch (error) {
//       console.error('Error fetching banners:', error);
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (categoryname) {
//       fetchBanners();
//     }
//   }, [categoryname]);

//   return (
//     <div>
//       {loading ? <Loader service={service} /> : <DataCarousel banner={banner} />}
//     </div>
//   );
// };

// export default Carousel;




// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import DataCarousel from "./DataCarousel";
// import Loader from "./Loader";
// import { baseUrl } from "../data/data";

// // ✅ Local Images
// import trivia1 from "../assets/trivia1.png";
// import trivia2 from "../assets/trivia2.png";
// import trivia3 from "../assets/trivia3.png";

// const Carousel = ({ ani, service }) => {
//   const [banner, setBanner] = useState([]);
//   const [loading, setLoading] = useState(false);

//   // 🔥 FAITH → Use Local Images
//   useEffect(() => {
//     if (service?.toLowerCase() === "faith") {
//       setBanner([
//         { imgurl: trivia1 },
//         { imgurl: trivia2 },
//         // { imgurl: trivia3 },
//       ]);
//       return; // stop API call
//     }

//     fetchBanners();
//   }, [ani, service]);

//   const fetchBanners = async () => {
//     try {
//       setLoading(true);

//       const res = await axios.get(
//         `${baseUrl}/api/subscription/redirect/?msisdn=${ani}&service=${service}&result=active`
//       );

//       const category = res?.data?.[0]?.category_name;

//       if (!category) {
//         setBanner([]);
//         setLoading(false);
//         return;
//       }

//       const bannerRes = await axios.get(
//         `${baseUrl}/api/banner/${category}`
//       );

//       // Make sure API data contains imgurl
//       setBanner(bannerRes.data || []);
//       setLoading(false);
//     } catch (error) {
//       console.error("Error fetching banners:", error);
//       setLoading(false);
//     }
//   };

//   if (loading) return <Loader />;

//   return (
//     <DataCarousel
//       banner={banner}
//       isFaith={service?.toLowerCase() === "faith"}
//     />
//   );
// };

// export default Carousel;


import React, { useEffect, useState } from "react";
import axios from "axios";
import DataCarousel from "./DataCarousel";
import Loader from "./Loader";
import { baseUrl } from "../data/data";

// ✅ Local Images
import trivia1 from "../assets/trivia1.png";
import trivia2 from "../assets/trivia2.png";

const Carousel = ({ ani, service }) => {
  const [banner, setBanner] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchBanners();
  }, [ani, service]);

  const fetchBanners = async () => {
    try {
      setLoading(true);

      const res = await axios.get(
        `${baseUrl}/api/subscription/redirect/?msisdn=${ani}&service=${service}&result=active`
      );

      const category = res?.data?.[0]?.category_name;

      if (!category) {
        setBanner([]);
        setLoading(false);
        return;
      }

      const bannerRes = await axios.get(
        `${baseUrl}/api/banner/${category}`
      );

      const apiBanners = bannerRes.data || [];

      // 🔥 FAITH → Merge API + Static banners
      if (service?.toLowerCase() === "faith") {
        const staticBanners = [
  { imgurl: trivia1, isStatic: true },
  { imgurl: trivia2, isStatic: true },
];

        const merged = [];

        apiBanners.forEach((apiBanner, index) => {
          // Push API banner
          merged.push(apiBanner);

          // Push static banner alternately
          const staticBanner =
            staticBanners[index % staticBanners.length];

          merged.push(staticBanner);
        });

        setBanner(merged);
      } else {
        setBanner(apiBanners);
      }

      setLoading(false);
    } catch (error) {
      console.error("Error fetching banners:", error);
      setLoading(false);
    }
  };

  if (loading) return <Loader />;

  return (
    <div className="w-full">

    <DataCarousel
      banner={banner}
      isFaith={service?.toLowerCase() === "faith"}
    />
    </div>
  );
};

export default Carousel;